// libs/react-mosaic-component/src/lib/types.ts
var MosaicDragType = {
  WINDOW: "MosaicWindow"
};
export {
  MosaicDragType
};
